import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCSelect, BCSelectCont } from "../../../styled/global.styled";

const SelectField = ({ field, register, isRequired }: BcFieldProps) => (
    <div className="bc-form-field">
        <BCSelectCont>
            <BCSelect
                className="bc-input"
                id={field.item}
                aria-label={field.label}
                placeholder={field.placeholder}
                {...register(field.item, { required: isRequired })}

            >
                <option value="">{`Selecciona el/la ${field.label}`}</option>
                {field?.options?.map((option: any) => (
                    <option key={option.value} value={option.value}>
                        {option.name}
                    </option>
                ))}
            </BCSelect>
            <label htmlFor={field.item}>{field.label}</label>
        </BCSelectCont>
    </div>
);

export default SelectField;